package com.appcreator.blueprint.conversions

import com.appcreator.blueprint.core.Conversion
import com.appcreator.blueprint.core.ConversionClass
import com.appcreator.blueprint.core.GenericDefault
import com.appcreator.blueprint.core.InputProperty
import com.appcreator.blueprint.core.properties.DataPath
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("SubstringConversion")
@ConversionClass(
    title = "Substring",
    availableFrom = "0.0.1"
)
data class SubstringConversion(
    @InputProperty(
        title = "Value",
        availableFrom = "0.0.1"
    )
    val value: String?,

    @InputProperty(
        title = "Start",
        availableFrom = "0.0.1"
    )
    val start: Int?,

    @InputProperty(
        title = "End",
        availableFrom = "0.0.1"
    )
    val end: Int?,
): Conversion
